import './Group.sass';

export const Group = ({children}) => <div className="group">{children}</div>;
